module.exports = __webpack_public_path__ + "static/media/avocado_serum.0cb7909b.png";